// @flow

export const getClientId = (): string =>
  process.env.IN_CHROMECAST_MODE ? 'CastReceiver' : 'Web_Browser';

export const getUniqueId = (): string => '';
